import AuthLayout from "../layouts/AuthLayout";
import Login from "../components/Auth/Login";

const LoginPage = () => {
  return (
    <AuthLayout>
      <Login />
    </AuthLayout>
  );
};

export default LoginPage;
